import { AuthRepositoryImplementation } from '../infrastructure/auth-repository-implementation';
import { AuthResponseFactory } from '../domain/auth/model';

const repo = new AuthRepositoryImplementation();
async function signInWithEmailAndPassword(email: string, password: string) {
    const data = await repo.signInWithEmailAndPassword(email, password).toPromise();
    const response = AuthResponseFactory.create(
        data.data.displayName,
        data.data.email,
        data.data.expiresIn,
        data.data.idToken,
        data.data.kind,
        data.data.refreshToken,
        data.data.registered,
        data.data.uid,
    );
    if (data.data.statusCode > 200) {
        throw new Error(data.data.message);
    }
    return response;
}

export { signInWithEmailAndPassword }
